export default __webpack_public_path__ + "static/turbo-lora-94bcf6a262492c761cf7c72c6bb83431.png";